import styled from '@emotion/styled';

type SectionStyleTypes = {
  paddingTop?: number;
  paddingBottom?: number;
  paddingLeft?: number;
  paddingRight?: number;
  background?: string;
  bgPath?: string;
  visible?: boolean;
  display?: 'block' | 'flex' | 'grid' | 'inline-block' | 'inline-flex' | 'inline-grid' | 'none';
};

export const SectionStyle = styled.section<SectionStyleTypes>`

  background-color: ${(props:any) => props.theme.colors.b[props.background || 'white'] || 'transparent'};
  background-image: ${(props:any) => props.bgPath ? `url(/images/${props.bgPath})` : 'none'};
  background-size: cover;
  background-position: 50% 50%;

  visibility: ${(props:any) => props.visible ? 'visible' : 'hidden'};
  display: ${(props:any) => props.display || 'block'};

  > .section-inner {
    width: 100%;
    max-width: ${(props:any) => props.theme.layout.maxWidth};
    margin: 0 auto;
    padding-top: ${(props:any) => props.paddingTop ? props.paddingTop : 130}px;
    padding-bottom: ${(props:any) => props.paddingBottom ? props.paddingBottom : 130}px;
    padding-left: ${(props:any) => props.paddingLeft ? props.paddingLeft : 130}px;
    padding-right: ${(props:any) => props.paddingRight ? props.paddingRight : 130}px;

    a {
      &:hover {
        color: ${(props:any) => props.theme.colors.b.gr};
      }
    }
  }

  @media (max-width: ${(props:any) => props.theme.breakpoints.sm}) {
    > .section-inner {
      
    }
  }
`;
